<template>
    <div class="infor fl">
        <all-header
            :label="step == 'giveAMark' ? '专家点评' : lable"
            :ischage="ischage"
            :sublabel="step == 'giveAMark' ? '返回' : sublabel "
            :subtitle="subtitle"
            :year="oldyear"
            @getvalue="getvalue"></all-header>
        <div v-if="step == 0" class="block-list">
            <div
                v-for="(item, index) in awardList"
                :key="index"
                class="block-list-item">
                <div class="block-list-item-r-t">
                    {{ item.level }}
                </div>
                <div class="block-list-item-box">
                    <div class="block-list-item-box-t">
                        {{ item.title }}
                    </div>
                    <!--<div class="block-list-item-box-dtae">{{ item.year }}</div>-->
                    <!--<div-->
                    <!--  class="block-list-item-box-startend"-->
                    <!--  v-if="item.apply_at != undefined"-->
                    <!--  开始申报：{{ item.apply_at[0] }}-->
                    <!--</div>-->
                    <!--<div-->
                    <!--  class="block-list-item-box-startend"-->
                    <!--  v-if="item.apply_at != undefined"-->

                    <!--  结束申报：{{ item.apply_at[1] }}-->
                    <!--</div>-->
                </div>

                <div
                    class="block-list-item-box-b"
                    :class="item.status == 0 ? 'block-list-item-box-b-d' : ''"
                    @click="onApplyTap(item)">
                    <!-- {{ item.user_status==0?'去申请':item.user_status==1?'待审核':item.user_status==2?'已申报':'审核未通过' }} -->
                    去查看
                </div>
            </div>
        </div>
        <div v-if="step == 1">
            <el-select v-model="award_batch_id"
                       placeholder="请选择年份批次"
                       class="inpyabeb"
                       @change="getList">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(bitem,bindex) in award_batches" :label="bitem['year_label']" :value="bitem['id']"></el-option>
            </el-select>

            <!--<el-date-picker type="year"  placeholder="选择年份" v-model="year" class="inpyabeb" @change="getList"></el-date-picker>-->
            <el-table
                :data="formlist"
                :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                style="width: 100%; margin-top: 30px;margin-bottom:30px;">
                <el-table-column
                    prop="no"
                    label="材料编号"
                    min-width="80"></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    show-overflow-tooltip
                    prop="user.name"
                    label="企业名称"
                    min-width="140"></el-table-column>
                <el-table-column v-if="isGroupAward" prop="content.project_title" label="课题名称" show-overflow-tooltip
                                 min-width="90"></el-table-column>
                <el-table-column v-else prop="projectNname" label="项目名称" show-overflow-tooltip
                                 min-width="90"></el-table-column>
                <el-table-column
                    prop="created_at"
                    label="申报时间"
                    min-width="80"></el-table-column>
                <el-table-column min-width="70" label="查看材料">
                    <template slot-scope="scope">
                        <keep-alive>
                            <el-button
                                size="small"
                                style="color: #194abe"
                                @click="getapply(scope.row)">
                                查看材料
                            </el-button>
                        </keep-alive>
                    </template>
                </el-table-column>

                <el-table-column v-if="!isGroupAward" min-width="120" label="是否同意">
                    <template slot-scope="scope">
                        <el-button v-if="id != 12"
                                   size="mini"
                                   type="success"
                                   icon="el-icon-check"
                                   @click="handleEdit(scope.$index, scope.row)">
                            通过
                        </el-button>
                        <el-button v-if="id != 12"
                                   size="mini"
                                   style="color: red"
                                   icon="el-icon-close"
                                   @click="handleDelete(scope.$index, scope.row)">
                            打回
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column v-if="isGroupAward" min-width="70" label="专家点评">
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            style="color: #194abe"
                            @click="giveAMark(scope.row)">
                            去评分
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">
                <div class="yellow-box">
                    <span>{{ user.legal_representative_id }}</span>
                    <span>{{ user.name }}</span>
                    <span>申请提交于{{ user.created_at }}</span>
                </div>
                <textarea id="" v-model="reason" class="reason" name="" cols="30" rows="10" placeholder="点击输入无法通过审核的原因..."></textarea>
                <span slot="footer" class="dialog-footer">
                    <el-button
                        type="primary"
                        icon="el-icon-check"
                        @click="sumbit">确认提交</el-button>
                </span>
            </el-dialog>

            <pagetion :total="total" :page-size="pageSize" class="pos-page" @getpageValue="getpageValue"></pagetion>
        </div>

        <!-- 去评分 -->
        <div v-if="step == 'giveAMark'">
            <group-score-form
                :type="activeAward.content.project_type"
                :model="activeAward"
                @viewFile="() => getapply(activeAward)"
                @success="handleGiveAMarkSuccess">
            </group-score-form>
        </div>
    </div>
</template>

<script>
import AllHeader from '@/components/Modal/AllHeader'
import Pagetion from '@/components/Modal/Pagetion'
import GroupScoreForm from './applyAward/groupScoreForm.vue'
import {
    expertaward,//专家端审核奖项列表
    expertawardlogs,//专家端审核列表
    expertverify,//专家端审核是否通过
    AwardList,
    AwardInfo, //申报记录详情
    AwardLog, //申报奖项
    Address //填写地址
} from '../utils/api.js'
export default {
    components: {
        AllHeader,
        Pagetion,
        GroupScoreForm
    },
    data() {
        return {
            dialogVisible: false,
            step: 0,
            ischage: false,
            lable: '',
            pageSize: 20,
            total: 0,
            awardList: [],
            sublabel: '返回项目列表',
            subtitle: '', //副标题
            formlist: [],
            user:{},
            id:'',
            reason:'',
            year:null,
            oldyear:null,
            nowyear:null,
            award_batch_id:'',
            award_batches:[],
            activeAward: {},
            activeRow: {}
        }
    },
    computed: {
        isGroupAward() {
            return this.subtitle === '工程建设质量管理小组竞赛活动'
        }
    },
    mounted() {
        this.lable = this.$route.query.name
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.initList(1)
        this.nowyear = new Date().getFullYear()
        this.year = new Date().getFullYear().toString()
        console.log('year',this.year)
    },
    methods: {

        //分页
        getpageValue(index) {
            console.log(index)
            this.initgetList(index)
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => {})
        },
        async initList(page) {
            const data = {
                page_size: this.pageSize,
                page: page
            }
            let res = await expertaward(data)
            this.awardList = res.data || []
            this.total = res.total
        },
        async onApplyTap(row) {
            if(row.id == 21){
                this.$router.push('/gfprize/Awardbatch?award_id='+row.id)
                return;
            }
            const { id, status, title, content,year,award_batches } = row
            this.activeRow = row
            console.log(id, status, title, content,year)
            this.id = id;
            for(var i = 0; i < award_batches.length; i++){
                award_batches[i]['year_label'] = award_batches[i]['year']+'-'+award_batches[i]['batch']
            }
            console.log('award_batches',award_batches)
            this.award_batches = award_batches
            let res = await expertawardlogs(id,{year:this.year,'page_size': this.pageSize})
            this.formlist = res.data
            this.total = res.total
            console.log(this.total)
            this.formlist.forEach(e => {
                e.created_at = e.created_at.slice(0,10)
                if(e.award_id!=9||e.no==0){
                    e.no = e.id
                }
                if(e.award_id==9){
                    e.projectNname =e.content.Contractorinfo.projectNname
                }
                else{
                    e.projectNname = ''
                }
            })
            console.log(99,res)
            this.ischage = true
            this.step = 1
            this.subtitle = title
        },
        async onApplyReload(){
            let res = await expertawardlogs(this.id,{year:this.year,'page_size': this.pageSize})
            this.formlist = res.data
            this.total = res.total
            console.log(this.total)
            this.formlist.forEach(e => {
                e.created_at = e.created_at.slice(0,10)
                if(e.award_id!=9||e.no==0){
                    e.no = e.id
                }
                if(e.award_id==9){
                    e.projectNname =e.content.Contractorinfo.projectNname
                }
                else{
                    e.projectNname = ''
                }
            })
        },
        async getList(){
            console.log('year',this.year)

            //var year = this.year.getFullYear();
            //console.log('year',year)
            let res = await expertawardlogs(this.id,{award_batch_id:this.award_batch_id,'page_size': this.pageSize,'page':1})
            this.formlist = res.data
            this.total = res.total
            console.log(this.total)
            this.formlist.forEach(e => {
                e.created_at = e.created_at.slice(0,10)
                if(e.award_id!=9||e.no==0){
                    e.no = e.id
                }
                if(e.award_id==9){
                    e.projectNname =e.content.Contractorinfo.projectNname
                }
                else{
                    e.projectNname = ''
                }
            })
            console.log(99,res)
            this.ischage = true
            this.step = 1
        },
        async initgetList(page=1){
            console.log('year',this.year)

            //var year = this.year.getFullYear();
            // console.log('year',year)
            let res = await expertawardlogs(this.id,{'page_size': this.pageSize,'page':page,'award_batch_id':this.award_batch_id})
            this.formlist = res.data
            this.total = res.total
            console.log(this.total)
            this.formlist.forEach(e => {
                e.created_at = e.created_at.slice(0,10)
                if(e.award_id!=9||e.no==0){
                    e.no = e.id
                }
                if(e.award_id==9){
                    e.projectNname =e.content.Contractorinfo.projectNname
                }
                else{
                    e.projectNname = ''
                }
            })
            console.log(99,res)
            this.ischage = true
            this.step = 1
        },

        getvalue() {
            if(this.step == 'giveAMark'){
                this.step = 1;
                this.ischage = true;
            } else {
                this.step = 0
                this.ischage = false
                this.subtitle = ''
            }

        },
        getapply(obj) {
            if (obj.content) {
                var is_show_btn = this.id == 12 ? 0 : 1 //obj.created_at.substring(0,4) == this.nowyear ? 0 : 1;
                if (this.subtitle == '工程建设质量管理小组竞赛活动') {
                    is_show_btn = 0
                    const resolve = this.$router.resolve(`/word_1?title=${this.subtitle
                    }&id=${obj.id}&states=审核&is_show_btn=${is_show_btn
                    }&no_back=1&nav_title=预览项目评审材料`)
                    window.open(resolve.href, '_blank')
                } else {
                    //is_show_btn = 0
                    const resolve = this.$router.resolve(`/word_1?title=${this.subtitle
                    }&id=${obj.id}&states=审核&is_show_btn=${is_show_btn
                    }&no_back=1&nav_title=预览项目评审材料`)
                    window.open(resolve.href, '_blank')

                    //this.$router.push(`/word_1?title=${this.subtitle}&id=${obj.id}&states=审核&is_show_btn=${is_show_btn}`)
                }
            }
            if (obj.file_urls) {
                location.href = obj.file_urls[0]
            }
        },
        //通过
        handleEdit(a,b) {
            console.log(a,b)
            let data = {
                status:1
            }
            expertverify(data,b.id).then(res => {
                this.$message({
                    message: '审核成功',
                    type: 'success'
                })
                 this.onApplyReload()
                //this.$router.go(-1)
            }).catch(error => {
                this.$message({
                    message: error,
                    type: 'warning'
                })
            })
        },
        //立即提交
        sumbit(){
            if (this.reason=='') {
                this.$message.error('请填写不通过原因')
                return false
            }
            let data = {
                status:0,
                content:this.reason
            }
            expertverify(data,this.id).then(res => {
                console.log(996,res)
                this.$message({
                    message: '提交成功',
                    type: 'success'
                })
                this.onApplyReload()
                //this.$router.go(-1)
            }).catch(error => {
                this.$message({
                    message: error,
                    type: 'warning'
                })
            })
            this.dialogVisible = false
        },
        //不予通过
        handleDelete(a,b) {
            this.dialogVisible = true
            this.user = b.user
            this.id = b.id
        },
        // 去评分
        giveAMark(row) {
            this.step = 'giveAMark'
            this.activeAward = row
        },
        handleGiveAMarkSuccess() {
            this.step = '1'
            this.onApplyTap(this.activeRow)
        }
    }
}
</script>

<style>
</style>
<style lang="less" scoped>
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
.yellow-box{
    height: 40px;
    background: #FEF8EF;
    opacity: 1;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    span{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        &:nth-child(1){
            color: #194ABE;
        }
        &:nth-child(2){
            color: #0C0D0F;
        }
        &:nth-child(3){
            color: #7C828A;
            font-size: 14px;
        }
    }
}
.reason{
    margin-top: 20px;
    width: 100%;
    height: 162px;
    background: #FFFFFF;
    border: 1px solid #BDC3CB;
    opacity: 1;
    border-radius: 4px;
    outline: none;
    padding: 10px;
    box-sizing: border-box;
}
.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.block-list-item {
    padding-top:28px;
}
.inpyabeb {
    margin-top:20px;
}
</style>
